// GET ADMINISTRATORS LIST
export const GET_ADMINISTRATORS_LIST = 'GET_ADMINISTRATORS_LIST';
export const GET_ADMINISTRATORS_LIST_SUCCESS = 'GET_ADMINISTRATORS_LIST_SUCCESS';
export const GET_ADMINISTRATORS_LIST_FAILED = 'GET_ADMINISTRATORS_LIST_FAILED';

// GET EXTRANET ADMINISTRATORS LIST
export const GET_EXTRANET_ADMINISTRATORS_LIST = 'GET_EXTRANET_ADMINISTRATORS_LIST';
export const GET_EXTRANET_ADMINISTRATORS_LIST_SUCCESS = 'GET_EXTRANET_ADMINISTRATORS_LIST_SUCCESS';
export const GET_EXTRANET_ADMINISTRATORS_LIST_FAILED = 'GET_EXTRANET_ADMINISTRATORS_LIST_FAILED';

// GET ADMINISTRATORS DETAIL
export const GET_ADMINISTRATORS_DETAIL = 'GET_ADMINISTRATORS_DETAIL';
export const GET_ADMINISTRATORS_DETAIL_SUCCESS = 'GET_ADMINISTRATORS_DETAIL_SUCCESS';
export const GET_ADMINISTRATORS_DETAIL_FAILED = 'GET_ADMINISTRATORS_DETAIL_FAILED';

// ADD ADMINISTRATOR
export const ADD_ADMINISTRATOR = 'ADD_ADMINISTRATOR';
export const ADD_ADMINISTRATOR_SUCCESS = 'ADD_ADMINISTRATOR_SUCCESS';
export const ADD_ADMINISTRATOR_FAILED = 'ADD_ADMINISTRATOR_FAILED';

// CREATE ADMINISTRATOR PASSWORD
export const CREATE_ADMINISTRATOR_PASSWORD = 'CREATE_ADMINISTRATOR_PASSWORD';
export const CREATE_ADMINISTRATOR_PASSWORD_SUCCESS = 'CREATE_ADMINISTRATOR_PASSWORD_SUCCESS';
export const CREATE_ADMINISTRATOR_PASSWORD_FAILED = 'CREATE_ADMINISTRATOR_PASSWORD_FAILED';

// DELETE ADMINISTRATOR
export const DELETE_ADMINISTRATOR = 'DELETE_ADMINISTRATOR';
export const DELETE_ADMINISTRATOR_SUCCESS = 'DELETE_ADMINISTRATOR_SUCCESS';
export const DELETE_ADMINISTRATOR_FAILED = 'DELETE_ADMINISTRATOR_FAILED';

// EDIT ADMINISTRATOR
export const EDIT_ADMINISTRATOR = 'EDIT_ADMINISTRATOR';
export const EDIT_ADMINISTRATOR_SUCCESS = 'EDIT_ADMINISTRATOR_SUCCESS';
export const EDIT_ADMINISTRATOR_FAILED = 'EDIT_ADMINISTRATOR_FAILED';

// GET ACTION HISTORY LIST
export const GET_ACTION_HISTORY_LIST = 'GET_ACTION_HISTORY_LIST';
export const GET_ACTION_HISTORY_LIST_SUCCESS = 'GET_ACTION_HISTORY_LIST_SUCCESS';
export const GET_ACTION_HISTORY_LIST_FAILED = 'GET_ACTION_HISTORY_LIST_FAILED';

// GET MY PERMISSION
export const GET_MY_PERMISSION = 'GET_MY_PERMISSION';
export const GET_MY_PERMISSION_SUCCESS = 'GET_MY_PERMISSION_SUCCESS';
export const GET_MY_PERMISSION_FAILED = 'GET_MY_PERMISSION_FAILED';

// GET EXTRANET ADMINISTRATORS PLACE MANAGER
export const GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER = 'GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER';
export const GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_SUCCESS = 'GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_SUCCESS';
export const GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_FAILED = 'GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_FAILED';

// EDIT EXTRANET ADMINISTRATOR
export const EDIT_EXTRANET_ADMINISTRATOR = 'EDIT_EXTRANET_ADMINISTRATOR';
export const EDIT_EXTRANET_ADMINISTRATOR_SUCCESS = 'EDIT_EXTRANET_ADMINISTRATOR_SUCCESS';
export const EDIT_EXTRANET_ADMINISTRATOR_FAILED = 'EDIT_EXTRANET_ADMINISTRATOR_FAILED';

// DELETE EXTRANET ADMINISTRATOR
export const DELETE_EXTRANET_ADMINISTRATOR = 'DELETE_EXTRANET_ADMINISTRATOR';
export const DELETE_EXTRANET_ADMINISTRATOR_SUCCESS = 'DELETE_EXTRANET_ADMINISTRATOR_SUCCESS';
export const DELETE_EXTRANET_ADMINISTRATOR_FAILED = 'DELETE_EXTRANET_ADMINISTRATOR_FAILED';

// RESET EXTRANET ADMINISTRATOR PASSWORD
export const RESET_EXTRANET_ADMINISTRATOR_PASSWORD = 'RESET_EXTRANET_ADMINISTRATOR_PASSWORD';
export const RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS = 'RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS';
export const RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED = 'RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED';

// CHECK EXTRANET EMAIL
export const CHECK_EXTRANET_EMAIL = 'CHECK_EXTRANET_EMAIL';
export const CHECK_EXTRANET_EMAIL_SUCCESS = 'CHECK_EXTRANET_EMAIL_SUCCESS';
export const CHECK_EXTRANET_EMAIL_FAILED = 'CHECK_EXTRANET_EMAIL_FAILED';

// ADD EXTRANET ADMINISTRATOR
export const ADD_EXTRANET_ADMINISTRATOR = 'ADD_EXTRANET_ADMINISTRATOR';
export const ADD_EXTRANET_ADMINISTRATOR_SUCCESS = 'ADD_EXTRANET_ADMINISTRATOR_SUCCESS';
export const ADD_EXTRANET_ADMINISTRATOR_FAILED = 'ADD_EXTRANET_ADMINISTRATOR_FAILED';

// RESET INTRANET ADMINISTRATOR PASSWORD
export const RESET_INTRANET_ADMINISTRATOR_PASSWORD = 'RESET_INTRANET_ADMINISTRATOR_PASSWORD';
export const RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS = 'RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS';
export const RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED = 'RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED';
